
import Navbar from "../../components/Navbar";
import headerImage from "../../assets/lingotti/0057-Still-life-Care-is-gold-Modifica.webp";
import MinimalSection from "../../components/MinimalSection";
import FullMinimalSection from "../../components/FullMinimalSection";
import waterBar from "../../assets/lingotti/0020-Still-life-Care-is-gold-Modifica-2-Modifica-2.webp";
import slikBar from "../../assets/lingotti/0029-Still-life-Care-is-gold-Modifica-Copia.webp"
import { useState, useEffect } from "react";
import Footer from "../../components/Footer";
import oroIcon from '../../assets/oroPrestige/oroprestige icon.webp'
import { Helmet } from 'react-helmet';
import logo from '../../assets/oroPrestige/logo-trasp.webp';
import Static from "../../components/Static";
import AOS from "aos";
import "aos/dist/aos.css";


export default function ServiziInclusi() {
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    // togliere aos transition per mini-screen
    function initAOS() {
        AOS.init({
          disable: window.innerWidth <= 320 && window.innerHeight <= 256
        });
    }
      
    initAOS();
    
    window.addEventListener("resize", () => {
    AOS.refreshHard();
    });


    const firstSectionTitle = <h2 className="xl:text-4xl lg:text-3xl text-xl text-black mb-4 pt-5">Perché il prezzo dell’oro proposto da Careisgold è diverso dal fixing?</h2>
    const firstSectionDescription = <div className="space-y-4 text-pretty text-sm md:text-base xl:text-lg ">
        <p className="font-bold">Nemmeno Careisgold (né i suoi concorrenti) acquista oro al prezzo del fixing.</p>
        <p>Il prezzo dell’Oro fisico da investimento parte dal fixing giornaliero, ossia il valore di riferimento
            stabilito due volte al giorno sui mercati internazionali.</p>
        <p>Il
            <span className="font-bold"> London Gold Fixing</span> è il processo attraverso cui cinque delle principali banche mondiali —
            <span className="font-bold"> Barclays, HSBC, Société Générale, Bank of Nova Scotia e JP Morgan</span> — determinano in modo
            coordinato il prezzo ufficiale dell’oro.
        </p>
        <p>Tuttavia, quel numero rappresenta solo un <span className="font-bold">indice di riferimento</span>, che possiamo idealmente (o
            figurativamente) associare al <span className="font-bold">valore della materia prima grezza</span>. A questo, si somma uno <span className="font-bold">spread </span>
            che include i costi di estrazione, affinazione, fusione, lavorazione e blisteraggio del lingotto, nonché
            costi di trasporto, di custodia e serializzazione.</p>
        <p><span className="font-bold">Lo spread non è un sovrapprezzo</span>, ma la traduzione concreta di <span className="font-bold">tutto il valore reale </span> che ricevi:
            <span className="font-bold"> sicurezza, tracciabilità, assistenza, qualità, digitalizzazione e possibilità di rivendita.</span></p>
    </div>

    const secondSectionTitle = <span className="xl:text-4xl lg:text-3xl text-xl mb-4 pt-5 ">Cosa include il prezzo dell’oro proposto da Careisgold?</span>
    const secondSectionDescription = <div className="space-y-4 text-pretty text-sm md:text-base xl:text-lg p-2">
        <p className="font-bold italic">Ecco cosa trovi <span className="font-bold italic">in ogni grammo acquistato:</span></p>
        <ul className="list-disc space-y-4">
            <li><span className="font-bold">Oro puro 999,9‰</span> da raffinerie inserite nella Good Delivery List (LBMA)</li>
            <li><span className="font-bold">Spedizione tracciata</span> e/o <span className="font-bold">custodia assicurata</span> se si sceglie di detenerlo in caveau di massima sicurezza (Battistolli)</li>
            <li><span className="font-bold">Oro nominale</span>: ogni lingotto custodito in caveau ha un <span className="font-bold">codice seriale univoco intestato al cliente ed è inserito in una busta con un sigillo, sempre univoco, ad esso abbinato</span></li>
            <li><span className="font-bold">Copertura assicurativa completa</span> con Lloyd’s di Londra</li>
            <li><span className="font-bold">Portale digitale riservato</span> per la gestione dell’oro acquistato</li>
            <li><span className="font-bold">Supporto operativo</span> e assistenza professionale</li>
            <li><span className="font-bold">Servizi di compliance, tracciabilità, gestione documentale</span></li>
            <li>Possibilità di rivendita dell'oro depositato in caveau Battistolli individuati da Careisgold</li>
        </ul>
    </div>
    return (
        <>
            <Helmet>
                <title>Il nostro prezzo | Careisgold SpA</title>
                <meta name="description" content="Scopri cosa compone il prezzo dell’oro fisico: dal fixing ai servizi inclusi come custodia, assicurazione e assistenza." />
                <meta name="keywords" content="prezzo oro fisico oggi cosa include, perché l’oro Careisgold costa più del fixing, quanto costa davvero un lingotto d’oro,prezzo oro fisico con custodia assicurata, spread sul prezzo oro fisico spiegato, come viene calcolato il prezzo dell’oro 999.9, differenza tra fixing e prezzo lingotto, cosa comprende il prezzo dell’oro da investimento" />
                <meta property="og:title" content="Il nostro prezzo | Careisgold SpA" />
                <meta property="og:description" content="Scopri cosa compone il prezzo dell’oro fisico: dal fixing ai servizi inclusi come custodia, assicurazione e assistenza." />
                <meta property="og:image" content={headerImage} /> 
                <meta property="og:url" content="https://www.careisgold.it/servizi-inclusi/" />
                <meta property="og:type" content="page" /> 
                <link rel="canonical" href="https://www.careisgold.it/servizi-inclusi/" />
                <script type="application/ld+json">
                {`
                    {
                    "@context": "https://schema.org",
                    "@type": "WebPage",
                    "name": "Il nostro prezzo | Careisgold SpA",
                    "url": "https://www.careisgold.it/servizi-inclusi/",
                    "description": "Scopri cosa compone il prezzo dell’oro fisico: dal fixing ai servizi inclusi come custodia, assicurazione e assistenza.",
                    "inLanguage": "it",
                    "primaryImageOfPage": {
                        "@type": "ImageObject",
                        "url": "https://www.careisgold.it${headerImage}"
                    },
                    "publisher": {
                        "@type": "Organization",
                        "name": "Careisgold SpA",
                        "logo": {
                        "@type": "ImageObject",
                        "url": "https://www.careisgold.it${logo}"
                        },
                        "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "Via Monte Baldo 14/D",
                        "addressLocality": "Villafranca di Verona",
                        "addressRegion": "Veneto",
                        "postalCode": "37069",
                        "addressCountry": "IT"
                        },
                        "contactPoint": {
                        "@type": "ContactPoint",
                        "telephone": "+39 045 8213155",
                        "contactType": "Customer Service"
                        },
                        "sameAs": [
                        "https://www.facebook.com/careisgoldspa",
                        "https://www.instagram.com/careisgoldspa",
                        "https://www.linkedin.com/company/careisgold-spa"
                        ]
                    }
                    }
                `}
                </script>
            </Helmet>
            <Static
            headerImage={headerImage}
            title={`Il prezzo dell'oro fisico: cosa include`}
            description=''
            width='w-full'
            logoTransp=''
            arrow
            />
            <MinimalSection
                orientation='right'
                background='bg-white'
                title={firstSectionTitle}
                titleClass='text-4xl text-black mini-screen:text-xl'
                description={firstSectionDescription}
                descriptionClass='text-black mini-screen:text-base'
                imageUrl={waterBar}
                imgOpacity="opacity-100"
                strength='0.14'
                lerp='0.30'
                buttonClass1='hidden'
            />
            {width > 640 ? 
            <MinimalSection
                orientation='left'
                background='bg-black'
                title={secondSectionTitle}
                titleClass='text-4xl text-white mini-screen:text-xl'
                description={secondSectionDescription}
                descriptionClass='text-white mini-screen:text-base'
                imageUrl={slikBar}
                imgOpacity="opacity-100"
                strength='0.14'
                lerp='0.30'
                buttonClass1='hidden'
            /> :
            <FullMinimalSection
                headerImage={slikBar}
                title={secondSectionTitle}
                logoTransp=''
                logoPosition='left-[-40vh] top-[-30vh] w-[110vh]'
                description={secondSectionDescription}
                buttonClass='hidden'
            />}
            <div className="min-h-screen bg-white p-5 relative">
                <div className="mt-12 md:mt-20">
                    <h3 className="text-xl md:text-3xl font-bold mb-5">Cosa significa spread sull’oro fisico?</h3>
                    <p className=" md:text-xl">Lo spread è la <span className="font-bold">differenza tra </span> il prezzo finale al cliente e il <span className="font-bold">fixing ufficiale</span>.
                        <br /> Serve a coprire i costi <span className="font-bold">reali dei servizi</span> che rendono l’oro <span className="font-bold">acquistato più sicuro, protetto e rivendibile.</span></p>
                </div>
                <p className="text-xl md:text-3xl font-bold mt-14">Struttura del prezzo: da materia prima a servizio completo</p>
                <ul className="space-y-4 text-left mt-5 lg:text-xl md:text-lg md:w-[85vw] lg:w-[75vw] xl:w-[65vw] 2xl:w-[45vw] md:mx-auto">
                    <li className="flex items-start" data-aos="fade-up" data-aos-duration="900">
                        <img src={oroIcon} alt="oro" className="w-[20px] md:w-[25px] mr-2" />
                        <p><span className="font-bold">Raffinazione e confezionamento:</span> adattamento dell’oro grezzo a lingotti certificati</p>
                    </li>
                    <li className="flex items-start" data-aos="fade-up" data-aos-duration="900">
                        <img src={oroIcon} alt="oro" className="w-[20px] md:w-[25px] mr-2" />
                        <p><span className="font-bold">Custodia e assicurazione:</span> deposito presso caveau e copertura Lloyd’s</p>
                    </li>
                    <li className="flex items-start" data-aos="fade-up" data-aos-duration="900">
                        <img src={oroIcon} alt="oro" className="w-[20px] md:w-[25px] mr-2" />
                        <p><span className="font-bold">Logistica e tracciamento:</span> trasporto, documentazione</p>
                    </li>
                    <li className="flex items-start" data-aos="fade-up" data-aos-duration="900">
                        <img src={oroIcon} alt="oro" className="w-[20px] md:w-[25px] mr-2" />
                        <p><span className="font-bold">Gestione digitale:</span> piattaforma, portale personale, sicurezza dati</p>
                    </li>
                    <li className="flex items-start" data-aos="fade-up" data-aos-duration="900">
                        <img src={oroIcon} alt="oro" className="w-[20px] md:w-[25px] mr-2" />
                        <p><span className="font-bold">Assistenza clienti:</span> supporto contrattuale e operativo</p>
                    </li>
                    <li className="flex items-start" data-aos="fade-up" data-aos-duration="900">
                        <img src={oroIcon} alt="oro" className="w-[20px] md:w-[25px] mr-2" />
                        <p><span className="font-bold">Servizi legali e compliance:</span> antiriciclaggio, normativa, protezione</p>
                    </li>
                    <li className="flex items-start" data-aos="fade-up" data-aos-duration="900">
                        <img src={oroIcon} alt="oro" className="w-[20px] md:w-[25px] mr-2" />
                        <p><span className="font-bold">Margine operativo:</span> funzionamento dell’infrastruttura aziendale</p>
                    </li>
                </ul>
                <div className="mb-10" data-aos="fade-in" data-aos-duration="900">
                    <p className="text-xl md:text-2xl mt-14">
                        Il prezzo finale riflette la somma di servizi tangibili associati a ogni singolo lingotto acquistato.
                    </p>
                    <p className="text-xl md:text-2xl font-bold mt-14">
                        Con Careisgold, non compri solo oro.
                        Compri una protezione su misura.
                    </p>
                    <p className="text-xl md:text-2xl italic mt-14">
                        E non dimenticare: l’oro resta tuo, sempre.
                    </p>
                    <p className="text-xl md:text-2xl italic">
                        Con la possibilità di rivenderlo, spedirlo  o ritirarlo quando vuoi.
                    </p>
                </div>
            </div>
        </>
    );
}